import React from "react";

const renderField = ({ input, label, meta: { touched, error, warning } }) => {
	return (
		<div>
			<div
				style={{
					display: "flex",
					justifyContent: "center",
					// alignItems: "center",
					marginTop: "10px"
				}}
			>
				<label
					style={{
						marginLeft: "10px",
						marginRight: "10px",
						textAlign: "center"
					}}
				>
					<input
						{...input}
						name={input.name}
						placeholder={label}
						type="radio"
						value="excellent"
						checked={input.value === "excellent"}
					/>
					Ótimo
				</label>
				<label
					style={{
						marginLeft: "10px",
						marginRight: "10px",
						textAlign: "center"
					}}
				>
					<input
						{...input}
						name={input.name}
						placeholder={label}
						type="radio"
						value="good"
						checked={input.value === "good"}
					/>
					Bom
				</label>
				<label
					style={{
						marginLeft: "10px",
						marginRight: "10px",
						textAlign: "center"
					}}
				>
					<input
						{...input}
						name={input.name}
						placeholder={label}
						type="radio"
						value="regular"
						checked={input.value === "regular"}
					/>
					Regular
				</label>
				<label
					style={{
						marginLeft: "10px",
						marginRight: "10px",
						textAlign: "center"
					}}
				>
					<input
						{...input}
						name={input.name}
						placeholder={label}
						type="radio"
						value="bad"
						checked={input.value === "bad"}
					/>
					Ruim
				</label>
				<label
					style={{
						marginLeft: "10px",
						marginRight: "10px",
						textAlign: "center"
					}}
				>
					<input
						{...input}
						name={input.name}
						placeholder={label}
						type="radio"
						value="veryBad"
						checked={input.value === "veryBad"}
					/>
					Insuficiente
				</label>
				<label
					style={{
						marginLeft: "10px",
						marginRight: "10px",
						textAlign: "center"
					}}
				>
					<input
						{...input}
						name={input.name}
						placeholder={label}
						type="radio"
						value="blank"
						checked={input.value === "blank"}
					/>
					Em Branco
				</label>
			</div>
			<div>
				{touched &&
					((error && <span>{error}</span>) ||
						(warning && <span>{warning}</span>))}
			</div>
		</div>
	);
};

export default renderField;